


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BPaginationNav, BDropdown, BDropdownItem } from 'bootstrap-vue';
import PagerOptions from '@/types/PagerOptions';

@Component({
    components: {
        'b-row': BRow,
        'b-col': BCol,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'b-form-group': BFormGroup,
        'b-pagination-nav': BPaginationNav
    }
})
export default class TablePager extends Vue {
    @Prop() config!: PagerOptions;

    pageSize = this.config.pageSize.toString();

    get showPager() {
        return this.config.pageSize > 0 && this.config.pageCount > 1;
    }

    onChangePage(page: number) {
        this.$emit('changePage', page);
    }

    onChangePageSize(pageSize: number) {
        this.pageSize = pageSize.toString();
        this.$emit('changePageSize', pageSize);
    }
}
